import React from 'react';

export function CoinIcon({ size = 16 }: { size?: number }) {
  return (
    <i
      className="coin-icon"
      aria-hidden="true"
      style={{ width: size, height: size }}
    />
  );
}